import axiosInstance from '../utils/axios';
import { TransactionOwnershipType } from "../@types/transactions";

const EXTEND_URL = '/purchases/v1/';
const REPORT_PURCHASE_URL = '/reports/purchases/v1/';

export type GetPurchasesQueryParams = {
  ownershipType: TransactionOwnershipType | TransactionOwnershipType[],
  merchantCode: string | undefined,
  page: number,
  size: number,
  dateFrom?: string,
  dateTo?: string,
  email?: string,
  programmeCode?: string,
  fields?: string[]
}

function getPurchasesByMerchantCodeApi(params: GetPurchasesQueryParams) {
  return axiosInstance.get(
    `${REPORT_PURCHASE_URL}`,
    { params , paramsSerializer: { indexes: null } }
  );
}

function getPurchaseByIdApi(id: string) {
  return axiosInstance.get(`${EXTEND_URL}${id}`)
}

export interface ICreateCheckoutSessionMerchantSaas {
  customerEmail: string;
  priceId: string;
  successUrl: string;
  cancelUrl: string;
}

function createCheckoutSessionForSaasSubscription(merchantCode: string, data: ICreateCheckoutSessionMerchantSaas) {
  return axiosInstance.post(
      `/purchases/v1/subscription/merchant-saas/checkout-session/${merchantCode}`, JSON.stringify(data));
}

interface IStartPurchaseByQuoteData {
  quoteId: string;
}

async function startPurchaseByQuote(data: IStartPurchaseByQuoteData) {
  return axiosInstance.post(`${EXTEND_URL}quote/start`, data, {});
}

interface ICreatePurchaseByQuoteData {
  emailAddress: string;
  paymentIntentId: string;
  paymentProvider: string;
  paymentProviderToken: string | null;
  quoteId: string;
}

async function createPurchaseByQuote(data: ICreatePurchaseByQuoteData) {
  return axiosInstance.post(`${EXTEND_URL}quote`, data, {})
}

export {
  getPurchasesByMerchantCodeApi,
  getPurchaseByIdApi,
  createCheckoutSessionForSaasSubscription,
  createPurchaseByQuote,
  startPurchaseByQuote,
};
